function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNetworkExplorer = function SvgNetworkExplorer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 500 158"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.857
    },
    fill: "#885ef4",
    d: "M65.5-.5h4c22.021 13.1 44.188 26.1 66.5 39a171.233 171.233 0 0 1-.5 32 36.17 36.17 0 0 0-7 4 483.12 483.12 0 0 1-1.5-31 2246.952 2246.952 0 0 1-67.5-40c2.307-.992 4.307-2.325 6-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.844
    },
    fill: "#682cfb",
    d: "M51.5 7.5c6.981 2.322 13.648 5.489 20 9.5a191.934 191.934 0 0 0 16 9.5c1.021.502 1.188 1.168.5 2a40.854 40.854 0 0 1-6.5 4 305.88 305.88 0 0 1-35-21c1.92-1.113 3.586-2.446 5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.762
    },
    fill: "#d88cff",
    d: "M39.5 14.5a52.08 52.08 0 0 1 8 5.5c-5.082 5.825-10.082 5.658-15-.5a38.268 38.268 0 0 0 7-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.91
    },
    fill: "#885df4",
    d: "M-.5 118.5v-80a633.171 633.171 0 0 0 26.5-16 107.86 107.86 0 0 1 8.5 5A1020.024 1020.024 0 0 1 8 43.5a1647.448 1647.448 0 0 0 0 80 105.03 105.03 0 0 1-8.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.86
    },
    fill: "#885ef4",
    d: "M52.5 23.5a8.434 8.434 0 0 1 4 .5l31 18.5-8 5a314.752 314.752 0 0 0-25.5-14A1457.742 1457.742 0 0 0 22.5 51a23.88 23.88 0 0 1-9-2.5c-.219-1.175.114-2.175 1-3a527.512 527.512 0 0 0 38-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.809
    },
    fill: "#885ef3",
    d: "M100.5 33.5c2.539 4.54 6.206 8.207 11 11a40.075 40.075 0 0 0-6.5 4l-3.5 7c-2.007-5.34-5.674-9.007-11-11 4.775-2.437 8.108-6.104 10-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.664
    },
    fill: "#885ef4",
    d: "M58.5 41.5c1.772 1.796 3.772 3.462 6 5 .886.825 1.219 1.825 1 3-2.6.78-4.6 2.446-6 5-.824-3.163-2.824-4.83-6-5v-3c3.333 0 5-1.667 5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.848
    },
    fill: "#885ef4",
    d: "M120.5 46.5c1.331 7.638 1.998 15.638 2 24l-1 24a523.75 523.75 0 0 0-32.5 19 25.249 25.249 0 0 1 0-10 829.131 829.131 0 0 1 23.5-14 761.95 761.95 0 0 0 1.5-39 59.772 59.772 0 0 0 6.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.809
    },
    fill: "#682cfb",
    d: "M38.5 47.5c3.016.34 5.682 1.507 8 3.5 1.211.893 1.211 1.726 0 2.5a62.794 62.794 0 0 1-11.5 6c-2.317-1.326-4.65-2.66-7-4-.688-.832-.521-1.498.5-2 3.635-1.664 6.968-3.664 10-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.838
    },
    fill: "#885ef4",
    d: "M218.5 50.5a560.338 560.338 0 0 1 25 53.5l-1 1.5c-2.088-.679-4.088-1.012-6-1-2.14-4.112-4.14-8.28-6-12.5-7.993-.5-15.993-.666-24-.5a41.815 41.815 0 0 1-6.5 14c-1.458-1.247-2.958-1.247-4.5 0l-1-1.5a5149.65 5149.65 0 0 1 24-53.5Zm0 14a3861.432 3861.432 0 0 1 9 20 54.56 54.56 0 0 1-18 .5 80.353 80.353 0 0 0 9-20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.814
    },
    fill: "#885ef4",
    d: "M248.5 50.5c1.175-.219 2.175.114 3 1a1384.055 1384.055 0 0 0 32.5 38c.5-12.329.667-24.662.5-37h7c.333 18.012 0 36.012-1 54a604.355 604.355 0 0 1-33.5-38 647.865 647.865 0 0 0-.5 36h-8v-54Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.834
    },
    fill: "#885ef4",
    d: "M372.5 50.5c22.194.367 32.361 11.7 30.5 34-6.325 19.746-19.158 25.913-38.5 18.5-12.68-10.38-15.846-23.213-9.5-38.5 4.237-6.745 10.071-11.412 17.5-14Zm0 7c11.265-1.288 18.765 3.378 22.5 14 2.523 10.07.023 18.57-7.5 25.5-13.267 5.694-22.433 1.861-27.5-11.5-3.028-12.807 1.138-22.14 12.5-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.844
    },
    fill: "#885ef4",
    d: "M499.5 101.5v4c-1.839-1.252-3.672-1.252-5.5 0a61.497 61.497 0 0 1-7.5-13.5 132.493 132.493 0 0 0-23 0 61.497 61.497 0 0 1-7.5 13.5 82.581 82.581 0 0 0-12 0A282.017 282.017 0 0 1 425.5 84a18.437 18.437 0 0 0-6-.5c.166 7.008 0 14.008-.5 21h-6c-.5-17.33-.667-34.663-.5-52 6.675-.166 13.342 0 20 .5 11.473 2.453 15.64 9.287 12.5 20.5-2.327 4.923-6.16 8.09-11.5 9.5a237.312 237.312 0 0 0 17 19.5 1260.199 1260.199 0 0 1 25-52 1798.308 1798.308 0 0 0 24 51Zm-80-43c4.767-.31 9.434.19 14 1.5 3.738 1.399 5.404 4.066 5 8-.015 4.694-2.348 7.694-7 9a72.442 72.442 0 0 1-12 .5v-19Zm55 7a663.521 663.521 0 0 1 10 19.5 54.56 54.56 0 0 1-18-.5 234.434 234.434 0 0 0 8-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.684
    },
    fill: "#885ef4",
    d: "M77.5 51.5c2.025 2.793 4.691 5.126 8 7a34.822 34.822 0 0 0-7 7c-1.333-3.333-3.667-5.667-7-7 3.832-.828 5.832-3.161 6-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.81
    },
    fill: "#885ef4",
    d: "M164.5 52.5c7.341-.166 14.674 0 22 .5 10.204 3.24 14.037 10.073 11.5 20.5-2.332 5.664-6.499 9.164-12.5 10.5a84.94 84.94 0 0 1-13 .5v20h-8v-52Zm7 7c5.713-1.551 11.38-1.051 17 1.5 5.503 8.302 3.503 13.969-6 17a30.499 30.499 0 0 1-11 0c1.326-6.266 1.326-12.432 0-18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.822
    },
    fill: "#885ef4",
    d: "M303.5 52.5c7.341-.166 14.674 0 22 .5 19.711 6.256 25.878 19.09 18.5 38.5-4.437 6.1-10.27 10.267-17.5 12.5-7.659.5-15.326.666-23 .5v-52Zm8 6c23.743-.792 31.91 9.875 24.5 32-5.808 5.605-12.808 8.272-21 8-1.728.046-3.228-.454-4.5-1.5a396.44 396.44 0 0 0 1-38.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.847
    },
    fill: "#d88cff",
    d: "M12.5 53.5a660.98 660.98 0 0 1 36.5 21 254.06 254.06 0 0 1-.5 39 36.168 36.168 0 0 0-7-4 452.225 452.225 0 0 1-1.5-30 260.723 260.723 0 0 0-16.5-10l-2 12a36.178 36.178 0 0 1-7-4 1657.457 1657.457 0 0 1-2-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.783
    },
    fill: "#672bfb",
    d: "M106.5 54.5c1.309 2.07 1.975 4.57 2 7.5l-.5 7.5a49.302 49.302 0 0 1-8 5 43.226 43.226 0 0 1 .5-16c2.411-.861 4.411-2.194 6-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.799
    },
    fill: "#d88bff",
    d: "M52.5 55.5a40.961 40.961 0 0 1 8 3.5c1.211.893 1.211 1.726 0 2.5a88.29 88.29 0 0 1-11 6 222.854 222.854 0 0 0-8-3c-.219-1.175.114-2.175 1-3 3.729-1.523 7.062-3.523 10-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.766
    },
    fill: "#d88cff",
    d: "M92.5 62.5c1.312 2.243 1.978 4.91 2 8l-1 8a80.525 80.525 0 0 0-7.5 4 43.226 43.226 0 0 1 .5-16c2.41-.861 4.41-2.194 6-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.828
    },
    fill: "#885ef4",
    d: "M66.5 64.5c.876-.13 1.543.203 2 1 1.981 6.648 6.315 10.981 13 13-6.993 2.326-11.66 6.993-14 14-1.569-7.235-5.902-11.902-13-14a139.632 139.632 0 0 0 9.5-6c1.707-2.409 2.54-5.076 2.5-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.871
    },
    fill: "#d88cff",
    d: "M106.5 76.5c1.277 1.194 1.944 2.86 2 5l-.5 5-25 15c-.667 7-.667 14 0 21a162.79 162.79 0 0 0 10.5-6c1.333 3.333 1.333 6.667 0 10a267.454 267.454 0 0 1-19 11l-1-1c.65-13.634 1.317-27.301 2-41a704.286 704.286 0 0 0 31-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.745
    },
    fill: "#885ef4",
    d: "M134.5 76.5c1.277 1.194 1.944 2.86 2 5l-1 5a36.17 36.17 0 0 0-7 4c-2.408-6.778-.408-11.445 6-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.842
    },
    fill: "#885ef4",
    d: "M26.5 78.5a26.388 26.388 0 0 1 8 4 452.211 452.211 0 0 1 1.5 30A492.994 492.994 0 0 0 67.5 131c1.122 3.409 1.289 6.909.5 10.5l-41-24a760.881 760.881 0 0 1-.5-39Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.808
    },
    fill: "#682cfb",
    d: "M12.5 84.5a26.054 26.054 0 0 1 9.5 5 294.557 294.557 0 0 1-.5 42l-7-4c-.7-14.366-1.366-28.699-2-43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.811
    },
    fill: "#d88cff",
    d: "M54.5 91.5a120.702 120.702 0 0 0 13 7 25.87 25.87 0 0 1 1 10c-4.215-1.441-8.215-3.441-12-6a144.073 144.073 0 0 1-2-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#682cfb",
    d: "M134.5 92.5c1.265 1.014 1.931 2.514 2 4.5a14.435 14.435 0 0 1-1 5 1863.516 1863.516 0 0 1-35.5 20.5 41.549 41.549 0 0 1 1.5-10.5 1198.913 1198.913 0 0 0 33-19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.819
    },
    fill: "#682cfb",
    d: "M54.5 107.5a280.626 280.626 0 0 1 13.5 8 25.249 25.249 0 0 1 0 10 200.758 200.758 0 0 0-11.5-7 144.091 144.091 0 0 1-2-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.859
    },
    fill: "#885ef4",
    d: "M69.5 157.5h-4c-8.02-5.1-16.186-10.1-24.5-15a25.249 25.249 0 0 1 0-10L65.5 147c1.333.667 2.667.667 4 0a4092.772 4092.772 0 0 0 66-38.5c1.291 3.545 1.291 7.045 0 10.5a3147.471 3147.471 0 0 0-66 38.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.708
    },
    fill: "#d88bff",
    d: "m26.5 124.5 8 4a25.87 25.87 0 0 1 1 10c-2.966-.898-5.8-2.231-8.5-4a50.442 50.442 0 0 1-.5-10Z"
  }));
};
export default SvgNetworkExplorer;